// extracted by css-extract-rspack-plugin
export default {"root":"UZYdN","readOnly":"TDWIl","icon":"NmvuX"};